var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('vue-headful',{attrs:{"title":_vm.title}}),_c('slim-grid',{attrs:{"data":_vm.gridData,"columnOptions":_vm.columnOptions,"pk":"field__name","height":1200}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }